import type { SmishingRequestCategory } from "./smishing-chat-api";
import { getSmishingInputSuggestions } from "./smishing-input-helper";

interface SmishingInputHelperProps {
  category?: SmishingRequestCategory;
  language?: string;
  disabled?: boolean;
  onSelect: (value: string) => void;
}

export function SmishingInputHelper({
  category,
  language,
  disabled = false,
  onSelect,
}: SmishingInputHelperProps) {
  const suggestions = getSmishingInputSuggestions(category, language);

  if (!category || suggestions.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2 px-2 pb-2 pt-1">
      {suggestions.map(suggestion => (
        <button
          key={suggestion}
          type="button"
          disabled={disabled}
          onClick={() => onSelect(suggestion)}
          className="rounded-full border border-black/10 bg-white/70 px-3 py-1 text-[12px] text-[#1C1C1E] backdrop-blur-sm transition-opacity disabled:opacity-40 dark:border-white/15 dark:bg-white/10 dark:text-[#F2F2F7]"
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
}
